
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!Pricing/PricingPaywallComponent',['require','jquery','underscore','react','lib/react/React.PodioView','translate','component!Pricing/PricingUpgradeOnlyBoxComponent','component!ModalComponent','services/ContractService','controllers/conversations/Podio.Controllers.Conversations.New','lib/view_helpers/base','lib/Podio.Routes','lib/Podio.Utils','lib/Podio.Config','react-element-to-html','lib/Podio.Utils','models/Podio.Models.User'],function (require) {
  'use strict';

  var $ = require('jquery');
  var _ = require('underscore');
  var React = require('react');
  var PodioView = require('lib/react/React.PodioView');
  var t = require('translate');

  var PricingUpgradeOnlyBoxComponent = require('component!Pricing/PricingUpgradeOnlyBoxComponent');
  var ModalComponent = require('component!ModalComponent');

  var ContractService = require('services/ContractService');

  var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');

  var viewHelpers = require('lib/view_helpers/base');
  var routes = require('lib/Podio.Routes');
  var utils = require('lib/Podio.Utils');
  var config = require('lib/Podio.Config');
  var reactElementToString = require('react-element-to-html');
  var podioUtils = require('lib/Podio.Utils');

  var User = require('models/Podio.Models.User');
  var user = new User();

  var FeatureMap = {
    'advanced_workflows': t('Premium workflow effects #premium_flows'),
    'advanced_workflows_conditions': t('Workflow conditions #premium_flows'),
    'read_only_item_share': t('Read only item share #readonly.itemshare'),
    'report_charts': t('Report charts #report_charts'),
    'user_management': t('User management #paywall'),
    'workspace_management': t('Workspace management #paywall'),
    'reporting': t('Reporting #paywall'),
    'item_limit_eighty': t('You have exceeded 80% of the item limit for your plan. #paywall'),
    'item_limit_reached': t('You have reached the item limit for your plan. #paywall'),
    'partial_excel_import': t("This file import requires exceeding the 100% item limit included in your plan. #paywall")
  };

  var PricingPaywallComponent = PodioView.extend({
    displayName: 'PricingPaywallComponent',

    getInitialState: function getInitialState() {
      this.modal = React.createRef();
      return {
        upgradePath: null,
        currentOrganization: {},
        isLoading: true
      };
    },

    getDefaultProps: function getDefaultProps() {
      return {
        isOpen: false,
        feature: null,
        organization: null,
        skipCheck: false
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      if (this.props.isOpen) {
        this.ensurePermissions();
      }

      user.setProperty('tier_upgrade_return_url', { url: window.location.href });
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'pricing-paywall-component' },
        React.createElement(
          ModalComponent,
          _extends({ ref: this.modal, onClose: this.close }, this.props),
          this.state.isLoading ? React.createElement('div', null) : this.renderCopy()
        )
      );
    },

    renderCopy: function renderCopy() {
      var isSterlingOrAppleContract = _.isDefined(this.state.contract) && _.contains(['sterling', 'apple'], this.state.contract.accounting_provider);
      var isSponsored = this.state.currentOrganization.type === 'sponsored';
      var isAdvancedWorkflowsFeature = _.contains(['advanced_workflows', 'advanced_workflows_conditions'], this.props.feature);

      if (isSterlingOrAppleContract || isSponsored) {
        return this._renderSterlingContract(isSponsored);
      }
      if (this.state.currentOrganization.role === 'light' || this.state.isContractViewer === false) {
        if (podioUtils.showFeature('limit_to_500_items') && (this.props.feature === 'item_limit_reached' || this.props.feature === 'item_limit_eighty')) {
          return React.createElement(
            'div',
            { className: 'modal-content' },
            this.props.feature === 'item_limit_reached' && React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/locked_icon.png') }),
            this.props.feature === 'item_limit_eighty' && React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/80_Modal.svg') }),
            React.createElement(
              'h2',
              null,
              t('{0}').format(FeatureMap[this.props.feature])
            ),
            React.createElement(
              'p',
              null,
              t('Ask the person looking after {0} organisation to upgrade, #tier.paywall').format(this.state.currentOrganization.name),
              ' or contact ',
              React.createElement(
                'a',
                { href: 'https://docs.sharefile.com/en-us/podio', target: '_blank' },
                t('Podio Support #tier.paywall')
              )
            )
          );
        } else if (podioUtils.showFeature('limit_to_500_items') && this.props.feature === 'partial_excel_import') {
          return React.createElement(
            'div',
            { className: 'modal-content' },
            React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/warning.svg') }),
            React.createElement(
              'h2',
              null,
              t('{0}').format(FeatureMap[this.props.feature])
            ),
            React.createElement(
              'p',
              null,
              t('The file will be imported partially adding items from the top till the 100% limit is reached and the remaining rows will be skipped. #tier.paywall')
            ),
            React.createElement(
              'p',
              { onClick: this.props.methodToCall, className: 'secondary-button' },
              t('Proceed with import #tier.paywall')
            )
          );
        } else {
          return React.createElement(
            'div',
            { className: 'modal-content' },
            React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/locked_icon.png') }),
            React.createElement(
              'h2',
              null,
              t('{0} is a feature not included in your plan. #tier.paywall').format(FeatureMap[this.props.feature])
            ),
            isAdvancedWorkflowsFeature ? this._renderGlobiFlowUpgradeMessage() : null,
            React.createElement(
              'p',
              null,
              t('Ask the person looking after {0} organisation to upgrade, #tier.paywall').format(this.state.currentOrganization.name),
              ' or contact ',
              React.createElement(
                'a',
                { href: 'https://docs.sharefile.com/en-us/podio', target: '_blank' },
                t('Podio Support #tier.paywall')
              )
            )
          );
        }
      } else if (isAdvancedWorkflowsFeature && !config.user.from_sharefile) {
        return this.renderAdvancedWorkflows();
      } else if (podioUtils.showFeature('limit_to_500_items') && (this.props.feature === 'item_limit_reached' || this.props.feature === 'item_limit_eighty')) {
        return React.createElement(
          'div',
          { className: 'modal-content' },
          this.props.feature === 'item_limit_reached' && React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/locked_icon.png') }),
          this.props.feature === 'item_limit_eighty' && React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/80_Modal.svg') }),
          React.createElement(
            'h2',
            null,
            t('{0}').format(FeatureMap[this.props.feature])
          ),
          React.createElement(
            'p',
            null,
            t('To continue adding items, upgrade your plan. #tier.paywall')
          ),
          React.createElement(
            'p',
            null,
            React.createElement(
              'a',
              { href: this.state.upgradePath, className: 'button-new primary' },
              t('Upgrade Now #tier.paywall')
            )
          )
        );
      } else if (podioUtils.showFeature('limit_to_500_items') && this.props.feature === 'partial_excel_import') {
        return React.createElement(
          'div',
          { className: 'modal-content' },
          React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/warning.svg') }),
          React.createElement(
            'h2',
            null,
            t('{0}').format(FeatureMap[this.props.feature])
          ),
          React.createElement(
            'p',
            null,
            t('The file will be imported partially adding items from the top till the 100% limit is reached and the remaining rows will be skipped. #tier.paywall')
          ),
          React.createElement(
            'p',
            { onClick: this.props.methodToCall, className: 'secondary-button' },
            t('Proceed with import #tier.paywall')
          ),
          React.createElement(
            'p',
            null,
            React.createElement(
              'a',
              { href: this.state.upgradePath, className: 'button-new primary' },
              t('Upgrade Now #tier.paywall')
            )
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: 'modal-content' },
          React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/locked_icon.png') }),
          React.createElement(
            'h2',
            null,
            t('{0} is a feature not included in your plan. #tier.paywall').format(FeatureMap[this.props.feature])
          ),
          React.createElement(
            'p',
            null,
            t('To access this feature you need to upgrade. #tier.paywall')
          ),
          React.createElement(
            'p',
            null,
            React.createElement(
              'a',
              { href: this.state.upgradePath, className: 'button-new primary' },
              t('Upgrade Now #tier.paywall')
            )
          )
        );
      }
    },

    _renderGlobiFlowUpgradeMessage: function _renderGlobiFlowUpgradeMessage() {
      var pricingPageLink = routes.organization_pricing_path(this._getOrgSlug(), { format: 'html' });
      var plusPlanLink = reactElementToString(React.createElement(
        'a',
        { href: pricingPageLink },
        'Plus plan'
      ));
      var premPlanLink = reactElementToString(React.createElement(
        'a',
        { href: pricingPageLink },
        'Premium plan'
      ));
      var globiFlowSiteLink = reactElementToString(React.createElement(
        'a',
        { href: 'http://www.globiflow.com/' },
        'GlobiFlow'
      ));
      var html = t('Upgrade to the {0} to get access to Podio workflows or upgrade to the {1} to get even more workflow capabilities with the {2} extension. #tier.paywall').format(plusPlanLink, premPlanLink, globiFlowSiteLink);
      return React.createElement('p', { dangerouslySetInnerHTML: { __html: html } });
    },

    _renderSterlingContract: function _renderSterlingContract(isSponsored) {
      var copy = {
        header: {
          sponsored: t('Your organisation is currently on a sponsored plan #tier.paywall')
        },
        content: {
          apple: t('If you want to upgrade to access this feature, please contact support. #tier.paywall'),
          sterling: t('If you want to upgrade to access this feature, please contact support. #tier.paywall'),
          sponsored: t('If you want to upgrade to access this feature, please contact support. #tier.paywall')
        }
      };

      var copyType = isSponsored ? 'sponsored' : this.state.contract.accounting_provider;

      return React.createElement(
        'div',
        { className: 'modal-wrapper' },
        React.createElement(
          'div',
          { className: 'modal-content' },
          React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/locked_icon.png') }),
          React.createElement(
            'p',
            null,
            isSponsored ? copy.header[copyType] : t('{0} is a feature not included in your plan. #tier.paywall').format(FeatureMap[this.props.feature])
          ),
          React.createElement(
            'span',
            null,
            copy.content[copyType]
          ),
          React.createElement(
            'p',
            null,
            React.createElement(
              'a',
              { className: 'button-new secondary message-button', href: 'https://docs.sharefile.com/en-us/podio', target: '_blank' },
              t('Contact support #support')
            )
          )
        )
      );
    },

    _getOrgSlug: function _getOrgSlug() {
      return this.state.currentOrganization && this.state.currentOrganization.url_label || 'undefined';
    },

    renderAdvancedWorkflows: function renderAdvancedWorkflows() {
      var tracking = {
        category: 'Paywall',
        value: this.props.feature,
        customDimension: {
          'paywall': this.props.feature
        }
      };

      return React.createElement(
        'div',
        { className: 'modal-content advanced-workflows' },
        React.createElement(
          'p',
          { className: 'locked' },
          t('Currently locked #better_paywall')
        ),
        React.createElement(
          'p',
          { className: 'title' },
          t('Advanced workflows is about saving time #better_paywall')
        ),
        React.createElement('img', { src: viewHelpers.image_url('components/PricingPaywallComponent/advanced_workflows.png') }),
        React.createElement(
          'p',
          { className: 'description' },
          React.createElement(
            'span',
            null,
            t('Imagine being able to create new tasks automatically, every time a project gets marked as “Done”. Or automatically move the deadline two weeks, if a projects gets delayed. Workflows will help you do that. Setting up these workflows will save you time and let you focus on whats important. #better_paywall')
          ),
          React.createElement(
            'a',
            { href: 'https://docs.sharefile.com/en-us/podio/using-podio/workflow-automation', target: '_blank' },
            'Read more here'
          )
        ),
        React.createElement(PricingUpgradeOnlyBoxComponent, { openModalDelegate: this.open, closeModalDelegate: this.close, needs: ['plus', 'premium'], downgrade: false, tracking: tracking }),
        React.createElement('div', { style: { clear: 'both' } }),
        React.createElement(
          'p',
          { className: 'all-features' },
          React.createElement(
            'a',
            { href: routes.organization_pricing_path(this._getOrgSlug(), { format: 'html' }), onClick: this.close },
            t('View all features #better_paywall')
          )
        )
      );
    },

    ensurePermissions: function ensurePermissions() {
      var self = this;
      if (this.props.skipCheck === true) {
        utils.getOrgByUrlLabel().then(function (organization) {
          self.setState({
            isLoading: false,
            currentOrganization: organization
          });
        });

        return;
      }

      var dfd = new $.Deferred();

      if (!_.isNull(this.props.organization)) {
        dfd.resolve(this.props.organization);
      } else {
        utils.getOrgByUrlLabel().then(dfd.resolve);
      }

      dfd.then((function (organization) {
        this.setUpgradePath(organization);

        if (organization.contract_status === 'none' && !_.contains(organization.rights, 'add_contract')) {
          this.setState({
            isContractViewer: false
          });
        }

        if (organization.contract_status !== 'none') {

          var contract = utils.getContractByOrg();

          contract.done((function (contract) {
            this.setState({
              contract: contract
            });
          }).bind(this));

          contract.fail((function () {
            this.setState({
              isContractViewer: false
            });
          }).bind(this));
        }

        this.setState({
          isLoading: false
        });
      }).bind(this));
    },

    setUpgradePath: function setUpgradePath(organization) {
      var upgradePath = routes.organization_upgrade_router_path(organization.url_label, { format: 'html' });

      this.setState({
        currentOrganization: organization,
        upgradePath: upgradePath
      });
    },

    open: function open() {
      this.ensurePermissions();

      this.modal.current.open();
    },

    close: function close() {
      if (this.state.isOpen) {
        this.modal.current.close();
      }

      //Redirect to the url. Happens only in case of excel import
      if (this.props.redirectUrl != undefined) {
        window.location.href = this.props.redirectUrl;
      }
    }
  });

  return PricingPaywallComponent;
});
